import { useEffect, useState, type FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useSplash } from './hooks/utils/use-splash';
import { request } from './common/request';
export const PaySuccess: FC = () => {
  const { t } = useAppTranslation();
  useSplash();
  const [status, setStatus] = useState('finish');
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const orderId = searchParams.get('order_id');
    if (!orderId) return;
    void request.infra.getOrderStatus.raw(orderId).then((res) => {
      if (res.code !== 200) {
        setStatus('');
        return;
      }
      if (res.data.status === 20) {
        setStatus(t('common.payment_success'));
      }
    });
  }, [t]);
  return <div>{status}</div>;
};
